/* eslint-disable no-underscore-dangle */
import { composeWithDevTools } from 'redux-devtools-extension';
import { configureStore } from '@reduxjs/toolkit';
import { LoginSlice } from "./slices/loginSlice";
//import { Fbsfbo } from './slices/fbs-fbo';
import { EditWidjets } from './slices/editWidjets';
import { CompanyClient } from './slices/companyClient';
import { MarketClient } from './slices/marketClient';
import { UploadPDF } from './slices/uploadPDF';
import { DealTab } from './slices/dealTab';
import { UploadImage } from './slices/uploadImage';
import tabSlice from './slices/tabSlice';

// Создание Redux store
// и подключение slices для управления состоянием приложения
// Используется composeWithDevTools для интеграции с Redux DevTools в браузере
const store = configureStore({
  reducer: {
      login: LoginSlice.reducer,
      //fbsfbo: Fbsfbo.reducer,
      editWidjets:EditWidjets.reducer,
      companyclient:CompanyClient.reducer,
      marketclient:MarketClient.reducer,
      uploadPDF:UploadPDF.reducer,
      UploadImage:UploadImage.reducer,
      DealTab:DealTab.reducer,
      tab: tabSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          immutableCheck: false,
          serializableCheck: false
      }),
      
},composeWithDevTools());

export default store;
function tabReducer(state: unknown, action: UnknownAction): unknown {
    throw new Error('Function not implemented.');
}

